import { Set } from 'immutable';

//  Return correct mapping.
const constants = {
	ASKAI_QUERY: 'askaiQuery',
	TRANSLATE_CONTENT: 'translateContent',
	ANALYZE_CONTENT: 'analyzeContent',
	CREATE_ANSWER: 'createAnswer',
	UPDATE_ANSWER: 'updateAnswer',
	DELETE_ANSWER: 'deleteAnswer',
	FORWARD_TO_QUESTION_FROM_ANSWER_ID: 'forwardToQuestionFromAnswerId',
	CREATE_COMMENT: 'createComment',
	UPDATE_COMMENT: 'updateComment',
	DELETE_COMMENT: 'deleteComment',
	CREATE_QUESTION: 'createQuestion',
	UPDATE_QUESTION: 'updateQuestion',
	DELETE_QUESTION: 'removeQuestion',
	SEARCH_QUESTIONS: 'searchQuestions',
	CLEAR_SEARCH: 'clearSearch',
	SEARCH_OPEN_CHANGED: 'searchOpenChanged',
	FETCH_MORE_QUESTIONS: 'fetchMoreQuestions',
	FETCH_EXPERT: 'fetchExpert',
	FETCH_ADMIN_CONFIG: 'fetchAdminConfig',
	UPDATE_ADMIN_CONFIG: 'updateAdminConfig',
	FETCH_EXPERTS_BY_ALL_TIME: 'fetchExpertsByAllTime',
	FETCH_EXPERTS_BY_WEEK: 'fetchExpertsByWeek',
	FETCH_EXPERTS_BY_TOPIC: 'fetchExpertsByTopic',
	FETCH_QUESTION_RELATED: 'fetchRelatedQuestions',
	FETCH_FEATURED_TOPICS: 'fetchFeaturedTopics',
	FETCH_ALL_TOPICS: 'fetchAllTopics',
	FETCH_ALL_TOPICS_BY_NAME: 'fetchAllTopicsByName',
	CREATE_TOPIC: 'createTopic',
	FETCH_TOPIC: 'fetchTopic',
	FETCH_TOPIC_BY_NAME: 'fetchTopicByName',
	DELETE_TOPIC: 'deleteTopic',
	UPDATE_TOPIC: 'updateTopic',
	EDIT_TOPIC: 'editTopic',
	RESET_EDITED_TOPIC: 'resetEditedTopic',
	FETCH_MORE_TOPICS: 'fetchMoreTopics',
	FETCH_MORE_FEATURED_TOPICS: 'fetchMoreFeaturedTopics',
	QUERY: 'query',
	QUERY_TOPIC: 'queryTopic',
	QUERY_TOPIC_CLEAR: 'queryTopicClear',
	QUERY_SPACES: 'querySpaces',
	QUERY_SPACE: 'querySpace',
	QUERY_SPACE_PERMISSIONS: 'querySpacePermissions',
	FETCH_QUESTION: 'fetchQuestion',
	FETCH_QUESTION_LIST: 'fetchQuestionList',
	FILTER: 'FILTER',
	RESET_ERRORS: 'resetErrors',
	VOTE_UP: 'voteUp',
	VOTE_DOWN: 'voteDown',
	FETCH_USER_VOTES: 'fetchUserVotes',
	FETCH_USER: 'fetchUser',
	FETCH_USER_GROUPS: 'fetchUserGroups',
	FETCH_USERS: 'fetchUsers',
	FETCH_ANSWERS: 'fetchAnswers',
	FETCH_ANSWER: 'fetchAnswer',
	FETCH_ANSWER_COUNT: 'fetchAnswerCount',
	ACCEPT_ANSWER: 'acceptAnswer',
	UNACCEPT_ANSWER: 'unAcceptAnswer',
	IS_WATCHING_SPACE: 'getWatchingSpace',
	WATCH_SPACE: 'watchSpace',
	UNWATCH_SPACE: 'unwatchSpace',
	IS_WATCHING_QUESTION: 'getWatchingQuestion',
	WATCH_QUESTION: 'watchQuestion',
	UNWATCH_QUESTION: 'unwatchQuestion',
	IS_WATCHING_ALL_QUESTIONS: 'getWatchingAllQuestions',
	WATCH_ALL_QUESTIONS: 'watchAllQuestions',
	UNWATCH_ALL_QUESTIONS: 'unwatchAllQuestions',
	IS_WATCHING_TOPIC: 'getWatchingTopic',
	WATCH_TOPIC: 'watchTopic',
	UNWATCH_TOPIC: 'unwatchTopic',
	OPEN_DELETE_DIALOG: 'openDeleteDialog',
	CLOSE_DELETE_DIALOG: 'closeDeleteDialog',
	OPEN_SHARE_DIALOG: 'openShareDialog',
	CLOSE_SHARE_DIALOG: 'closeShareDialog',
	COMPONENT_ERROR: 'componentError',
	ACTION_MESSAGE: 'actionMessage',
	DISMISS_FLAG: 'dismissFlag',
	SET_APP_READY: 'setAppReady',
	SWITCH_MACRO: 'switchMacro',
	FORWARD_ROUTE: 'forwardRoute',
	FETCH_AGGREGATED_DATA: 'fetchAggregatedData',
	GO_GLOBAL_ROUTE: 'goGlobalRoute',
	SWITCH_TO_GLOBAL_SPACE: 'switchToGlobalSpace',
	PAGE_VIEW_EVENT: 'pageViewEvent',
	HEADER_TABS: 'headerTabs',
};

export const ALL_FETCH_TOPIC_TYPES = Set([
	constants.FETCH_ALL_TOPICS,
	constants.FETCH_FEATURED_TOPICS,
	constants.FETCH_TOPIC_BY_NAME,
	constants.FETCH_MORE_TOPICS,
	constants.FETCH_MORE_FEATURED_TOPICS,
	constants.FETCH_ALL_TOPICS_BY_NAME,
]);

export default constants;
